// extracted by mini-css-extract-plugin
export var buttonContainer = "styles-module--buttonContainer--2e597";
export var content = "styles-module--content--b760b";
export var contentContainer = "styles-module--contentContainer--c9ab6";
export var image = "styles-module--image--1aa53";
export var imageContainer = "styles-module--imageContainer--31ef9";
export var section = "styles-module--section--80eee";